export default "__VITE_ASSET__GgifG4jXtHktadHRQ_fyew__"